import { redirect, useLoaderData } from 'react-router-dom';
import { AppDispatch } from '../app/store';
import { mainActions } from '../app/main-slice';
import { api } from '../app/api-slice';
import { urls } from '../navigation';

export async function salesIntegrationLoader(
    params: URLSearchParams,
    dispatch: AppDispatch
) {

    // session parameters
    const sessionid = params.get('sessionid');
    let languageid = params.get('languageid');
    const currency = params.get('currency');
    const userid = params.get('userid');
    const country = params.get('country');
    // sales screen parameters
    const customer = params.get('customer');
    const pricelist = params.get('pricelist');
    const pricelistcurrency = params.get('pricelistcurrency');
    const jobnumber = params.get('jobnumber');
    const taxesin_excluded = params.get('taxesin_excluded');
    // identification of model attributes
    const family = params.get('family');
    const variant = params.get('variant');

    let errors: string[] = [];

    if(sessionid && languageid && currency) {
        languageid = languageid.toLowerCase();
        dispatch(mainActions.logIn({
            lang: languageid,
            sessionId: sessionid,
            userId: userid ?? '',
            currency: currency,
            isAnonymous: false,
            taxesin_excluded: taxesin_excluded ?? undefined
        }))
    } else {
        for(let p of ['sessionid','languageid','currency']) {
            if(params.get(p) === null) {
                errors.push(`Missing loggin parameter: ${p}`);
            }
        }
    }

    if(country) {
        dispatch(mainActions.setCountry({ country, override: true }));
    }

    if( family && languageid ) {
        const categoryId = await dispatch(api.endpoints.getFamilyCategory.initiate(family)).unwrap();
        if(categoryId) {
            if(variant) {
                return redirect(urls.variantCfg(languageid, categoryId, family, variant));
            } else {
                const variants = await dispatch(api.endpoints.getVariants.initiate({ lang: languageid, family })).unwrap();
                if(variants) {
                    return redirect(urls.family(languageid, categoryId, family));
                } else {
                    return redirect(urls.familyCfg(languageid, categoryId, family));
                }
                
            }
        } else {
            errors.push(`Can't find family: ${family}`)
        }
    } else {
        errors.push(`Missing model parameter: family`);
    }

    return { errors };
}

export function SalesIntegrationPage() {

    const data = useLoaderData() as { errors: string[ ]}

    return data.errors.length > 0 ?
        <ul>
        {
            data.errors.map(e => <li>{e}</li>)
        }
        </ul>
        :
        <p>Redirecting...</p>
}